import * as yup from "yup";

export const webinarOrderSchema = yup.object().shape({
  personName: yup.string().required("Required"),
  amount: yup.number(),
  // receipt: yup.string(),
  date: yup.string(),
  email: yup.string().required("Required"),
  contact: yup.number().required("Required"),
  city: yup.string().required("Required"),
  age: yup.number().required("Required"),
  gender: yup.string().required("Required"),
});
